import { LazyImage } from '@components';
import { motion } from 'motion/react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { useMediaQueries, useStrapiImageFormat } from '@hooks';
import classNames from 'classnames';
import React, { useRef } from 'react';

const ContentBlockCard = ({ children, img, index }) => {
  const { isMobile } = useMediaQueries();
  const sliderRef = useRef(null);
  return (
    <motion.div
      initial={{
        opacity: 0,
        scale: 0.9,
        x: isMobile ? (index % 2 === 0 ? 50 : -50) : 0,
      }}
      whileInView={{ opacity: 1, scale: 1, x: 0 }}
      transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: index * 0.1,
      }}
      viewport={{ once: true, amount: 0.3 }}
      className={classNames(
        'flex flex-col-reverse md:flex-row  items-center my-5',
        { 'md:flex-row-reverse': index % 2 === 0 },
      )}
    >
      <div className="w-full flex flex-col justify-center items-center text-center space-y-1">
        {children}
      </div>

      <div
        className={classNames(
          'w-full rounded-[4px] max-h-[100vw] md:max-h-[50vw] xl:h-[30vw] md:mb-0 mb-5 overflow-hidden',

          index % 2 == 0 ? 'md:mr-5 lg:mr-10' : 'md:ml-5 lg:ml-10 ',
        )}
      >
        {img && (
          <>
            {img?.length > 1 ? (
              <Splide
                tag="section"
                ref={sliderRef}
                options={{
                  drag: true,
                  type: 'slide',
                  width: '100%',
                  autoplay: true,
                  pagination: false,
                  arrows: false,
                  padding: 0,
                  rewind: true,
                  snap: true,
                  perPage: 1,
                  perMove: 1,
                  focus: 0,
                  flickPower: 800,
                  flickMaxPages: 1,
                  lazyLoad: 'nearby',
                  gap: 8,
                  video: {
                    loop: true,
                    mute: true,
                  },
                }}
              >
                {img.map((item, i) => {
                  const { attributes } = item;

                  return (
                    <SplideSlide
                      key={i}
                      className={
                        'relative  h-full  max-h-[100vw] md:max-h-[50vw] w-full -z-10 rounded-t-sm  '
                      }
                    >
                      <LazyImage
                        img={useStrapiImageFormat({
                          img: attributes,
                        })}
                        alt="img"
                        skeletonCls="absolute left-0 top-0 right-0 bottom-0"
                        className={classNames(
                          'object-cover h-full relative max-h-[100vw] md:max-h-[50vw] w-full -z-10 rounded-t-sm ',
                        )}
                      />
                    </SplideSlide>
                  );
                })}
              </Splide>
            ) : (
              <LazyImage
                img={useStrapiImageFormat({ img })}
                alt="img"
                skeletonCls="absolute left-0 top-0 right-0 bottom-0"
                className={classNames(
                  'object-cover h-full  max-h-[100vw] md:max-h-[50vw] w-full -z-10 rounded-t-sm ',
                )}
              />
            )}
          </>
        )}
      </div>
    </motion.div>
  );
};

export default ContentBlockCard;
